import moment from 'moment';
import DigitalWalletChart from './DigitalWalletChart';

interface IProps {
  results: any;
  downloadReport: () => void;
}

const DigitalWalletSummary: (props: IProps) => JSX.Element = (props: IProps) => {

  const downloadReportHandler = () => {
    props.downloadReport();
  }

  return (
    <div className="mb-4">
      <ul className="wallet-summary mb-4">
        <li className='wallet-summary__item border-bottom'>
          <span className='color-monoIntense fs-16'>Address Summary</span>
          <div className='wallet-summary__table mt-3'>
            <ul className='wallet-summary__table-header d-flex color-monoNormal fs-12'>
                <li className='summary-col'>Token</li>
                <li className='summary-col'>Balance</li>
                <li className='summary-col'>Received Amount</li>
                <li className='summary-col'>Sent Amount</li>
                <li className='summary-col'>Latest Transaction</li>
                <li className='summary-col'>First Transaction</li>
            </ul>
            <ul className='wallet-summary__table-body mt-1'>
              {props.results.token_summary.map( (item: any) => { 
                const balance = (Math.round((+item.total_incoming_value_usd - +item.total_outgoing_value_usd) * 100) / 100).toFixed(2);

                return (
                <li className='d-flex hvg-bg color-monoIntense fs-13' key={item.token_symbol}>
                  <div className='summary-col'>{item.token_symbol}</div>
                  <div className='summary-col'>${balance}</div>
                  <div className='summary-col'>${item.total_incoming_value_usd}</div>
                  <div className='summary-col'>${item.total_outgoing_value_usd}</div>
                  <div className='summary-col'>{moment(item.latest_transaction_time).format('DD/MM/YYYY')}</div>
                  <div className='summary-col'>{moment(item.earliest_transaction_time).format('DD/MM/YYYY')}</div>
                </li>
              )})}
            </ul>
          </div>
        </li>
        <li className='wallet-summary__item border-bottom'>
          <button onClick={downloadReportHandler} className='wallet-summary__button'>
            <div className='d-flex justify-content-between align-items-center cursor-pointer'>
              <span className='color-monoIntense fs-16'>View full report</span>
              <img
                  className='cursor-pointer icon'
                  src={require('src/assets/images/icons/up-right-arrow.svg').default}
                  alt=""
              />
            </div>
          </button>
        </li>
      </ul>
      <DigitalWalletChart results={props.results?.token_summary} />
    </div>
  );
};

export default DigitalWalletSummary;
